import { render } from "./TrackPerformanceComponent.vue?vue&type=template&id=af4cfe36"
import script from "./TrackPerformanceComponent.vue?vue&type=script&lang=js"
export * from "./TrackPerformanceComponent.vue?vue&type=script&lang=js"

import "./TrackPerformanceComponent.vue?vue&type=style&index=0&id=af4cfe36&lang=css"

import exportComponent from "/tmp/build_1a3e5399/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__